import React from "react";
import { useNavigate } from "react-router-dom";
import LOgo from "../../assets/Ntact.png";
import Footer from "../../auth/Footer";
import { SUBCONTRACTOR_ROUTES } from "./routes";

const SubcontractorLogin = () => {
  const navigate = useNavigate();

  const handleStartNew = () => {
    // Clear any previous draft state
    sessionStorage.removeItem("subcontractorSubId");
    sessionStorage.setItem("subcontractorToken", "guest");
    navigate(`${SUBCONTRACTOR_ROUTES.form}?mode=new&allow=guest`);
  };

  const handleContinue = () => {
    navigate(SUBCONTRACTOR_ROUTES.retrieve);
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <div className="flex flex-grow items-center justify-center px-4 py-10">
        <div className="w-full max-w-3xl">
          {/* Title card */}
          <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-8 mb-6 text-center">
            <div className="flex justify-center mb-4">
              <img src={LOgo} alt="NTACT" className="h-16" />
            </div>
            <h1 className="text-2xl md:text-3xl font-semibold text-gray-900">
              Subcontractor Safety Pre-Qualification Form
            </h1>
          </div>

          {/* Two option cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Start a New Form */}
            <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-6 flex flex-col items-center">
              <h2 className="text-base font-semibold text-gray-900 mb-4">
                Start a New Form
              </h2>
              <button
                onClick={handleStartNew}
                className="w-full bg-gray-900 text-white text-sm font-medium py-3 rounded-md hover:bg-gray-800 transition"
              >
                Begin
              </button>
            </div>

            {/* Retrieve My Progress */}
            <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-6 flex flex-col items-center">
              <h2 className="text-base font-semibold text-gray-900 mb-4">
                Retrieve My Progress
              </h2>
              <button
                onClick={handleContinue}
                className="w-full border border-gray-300 text-gray-800 text-sm font-medium py-3 rounded-md hover:bg-gray-50 transition"
              >
                Continue Progress
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SubcontractorLogin;
